import 'prop-types';
import { createSlice } from '@reduxjs/toolkit';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';
import Cookie from 'universal-cookie';
import invariant from 'invariant';
import { createSimpleSelector } from '@dbh/reselect-extra';
import { isServerSideRendering } from '@dbh/environment';

/*
 *
 * Constants: `@dbh/universal-cookie`.
 *
 */const REDUX_AND_SAGA_KEY="UniversalCookie";

const initialState={// Leave this `undefined`, so we can detect `COOKIES_LOADED_IN_SSR` not being
// dispatched or not being correctly dispatched in `makeSelectSsrCookies`, and
// throw. Otherwise we get nasty bugs in the HTML from server side rendering,
// such as `SVG` `URLs` pointing to the wrong hostname.
cookies:void 0,isGDPRComplianceModeDisabled:!1},universalCookieSlice=createSlice({name:REDUX_AND_SAGA_KEY,initialState,reducers:{cookiesLoadedInSsr:withConformsTo("cookiesLoadedInSsr",[],(a,b)=>{const{payload:{cookies:c,isGDPRComplianceModeDisabled:d}}=b;a.cookies=c,a.isGDPRComplianceModeDisabled=d;}),cookiesRemovedAfterSSRFinished:()=>// This package is not supposed to be used in the browser; first, because
// the latest cookies are readily available there, no need to select them.
// Second, because the cookies in the `redux` store would be outdated,
// and using them instead of the updated values from the browser, would
// cause bugs.
initialState}});const {cookiesLoadedInSsr,cookiesRemovedAfterSSRFinished}=universalCookieSlice.actions;var reducer = universalCookieSlice.reducer;

const isSSR=isServerSideRendering(),throwInTheBrowser=a=>{invariant(isSSR,"(`"+a+"`) Expected to be in server side rendering. You should not call this function in the browser, use `useCookie` or freely import `Cookie` from `universal-cookie`; it will load the most updated cookies directly and automatically, from the browser.");};var throwInTheBrowser$1 = throwInTheBrowser;

const selectStateSlice=a=>a?a[REDUX_AND_SAGA_KEY]:void 0;var selectStateSlice$1 = selectStateSlice;

const fnName="makeSelectSsrCookies",makeSelectSsrCookies=()=>(throwInTheBrowser$1(fnName),createSimpleSelector(selectStateSlice$1,["cookies"],a=>(invariant(!!a,"(`makeSelectSsrCookies`) Expected cookies to be put in the reducer at the start of server side rendering, "),new Cookie(a))));/**
 * Returns a selector that returns an instance of the `Cookie` class, with
 * cookies from `express.js` loaded in it. To only be used in server side
 * rendering.
 * @return {Cookie} .
 */var makeSelectSsrCookies$1 = makeSelectSsrCookies;

/**
 * Returns `true` if the `GDPR` compliance mode is disabled (we use a
 * runtime switch). It should only be disabled for temporary tests agreed with
 * the company, otherwise the company can face big legal issues and fines.
 * @return {boolean} .
 */const makeSelectIsGDPRComplianceModeDisabled=()=>createSimpleSelector(selectStateSlice$1,["isGDPRComplianceModeDisabled"]);var makeSelectIsGDPRComplianceModeDisabled$1 = makeSelectIsGDPRComplianceModeDisabled;

export { REDUX_AND_SAGA_KEY, cookiesLoadedInSsr, cookiesRemovedAfterSSRFinished, makeSelectIsGDPRComplianceModeDisabled$1 as makeSelectIsGDPRComplianceModeDisabled, makeSelectSsrCookies$1 as makeSelectSsrCookies, reducer as universalCookieReducer };
